import isNil from 'lodash/isNil';

import type {SearchParamValue} from './search-params';

import {parsePath} from '.';

const searchStringWithExperiment = (params: Record<string, SearchParamValue> = {}) => {
    const search = new URLSearchParams();
    const experiments = new URLSearchParams(window.location.search).get('experiments');

    if (experiments) {
        search.set('experiments', experiments);
    }

    for (const [key, value] of Object.entries(params)) {
        if (!isNil(value)) {
            search.set(key, String(value));
        }
    }

    return search.toString() ? `?${search}` : '';
};

export const getRootLink = (params: Record<string, SearchParamValue> = {}) => {
    const {pathname} = parsePath(window.location.pathname);

    return pathname + searchStringWithExperiment(params);
};

export const getSubPageLink = (action: string, params: Record<string, SearchParamValue> = {}) => {
    const {pathname} = parsePath(window.location.pathname);

    return pathname + action + searchStringWithExperiment(params);
};
